const PLACEHOLDER_PATTERN = /\{\{\s*(\d+)\s*\}\}/g;

export function renderTemplateBody(
  bodyText = '',
  values: Record<string, string> = {},
): string {
  return String(bodyText || '').replace(
    PLACEHOLDER_PATTERN,
    (whole, number: string) => values[number] || whole,
  );
}
